import { Link } from 'react-router-dom';
import { BRAND_FULL } from '../../lib/brand';
import { directionsUrl, externalLink } from '../../lib/maps';

/**
 * Real links, not decoration. Crawlers weight internal linking, and a footer
 * is where a storage site legitimately repeats its address and hours.
 */
export default function PublicFooter({ facility }) {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto grid max-w-6xl gap-8 px-4 py-12 sm:grid-cols-3 sm:px-6">
        <div>
          <p className="text-sm font-extrabold tracking-tight text-slate-900">{BRAND_FULL}</p>
          {facility && (
            <address className="mt-2 not-italic text-sm leading-relaxed text-slate-600">
              {directionsUrl(facility.lat, facility.lng, facility.name) ? (
                <a href={directionsUrl(facility.lat, facility.lng, facility.name)} {...externalLink}
                   className="hover:text-slate-900 hover:underline">
                  {facility.address_line1}<br />
                  {facility.city}, {facility.state_code} {facility.postal_code}
                </a>
              ) : (
                <>
                  {facility.address_line1}<br />
                  {facility.city}, {facility.state_code} {facility.postal_code}
                </>
              )}
              {facility.phone && (
                <>
                  <br />
                  <a href={`tel:${facility.phone}`} className="hover:underline">{facility.phone}</a>
                </>
              )}
            </address>
          )}
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-slate-500">Storage</p>
          <ul className="mt-2 space-y-1.5 text-sm text-slate-600">
            <li><Link to="/search" className="hover:text-slate-900 hover:underline">Find a space</Link></li>
            <li><Link to="/register" className="hover:text-slate-900 hover:underline">Create an account</Link></li>
            <li><Link to="/login" className="hover:text-slate-900 hover:underline">Sign in</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-slate-500">Gate hours</p>
          {facility ? (
            <p className="mt-2 text-sm leading-relaxed text-slate-600">
              {facility.is_24h_access
                ? 'Open 24 hours, every day'
                : `${String(facility.gate_opens_at ?? '').slice(0, 5)} to ${String(facility.gate_closes_at ?? '').slice(0, 5)}, every day`}
            </p>
          ) : (
            <p className="mt-2 text-sm text-slate-600">See the facility page for current hours.</p>
          )}
        </div>
      </div>

      <div className="border-t border-slate-100 py-5 text-center text-xs text-slate-400">
        &copy; {new Date().getFullYear()} {BRAND_FULL}
      </div>
    </footer>
  );
}
